import React, { ReactElement } from "react";
import { useAppSelector } from "../../app/hooks";
import TabTitle from "./TabTitle";

type Props = {
  children: ReactElement[];
};

const Tabs: React.FC<Props> = ({ children }) => {
  const { selectedTab } = useAppSelector((state) => state.tabs);

  return (
    <div className="h-full">
      <ul className="flex border-b">
        {children.map((item, index) => (
          <TabTitle
            key={index}
            title={item.props.title}
            index={index}
            onClick={item.props.onClick}
          />
        ))}
      </ul>
      {children[selectedTab]}
    </div>
  );
};

export default Tabs;
